/** Un formulaire saisit des euros ; l'API ne parle qu'en centimes entiers. */
export function eurosToCents(euros: number): number {
  return Math.round(euros * 100);
}

export function centsToEuros(cents: number): number {
  return cents / 100;
}
